import React from "react";
import HorizontalScroller from "src/app/components/Tabs/components/HorizontalScroller";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import PageHeader from "src/app/components/PageHeader/PageHeader";
import PlanUpgradeNeededBox from "src/app/subscription/components/PlanUpgradeNeededBox/PlanUpgradeNeededBox";
import { SubscriptionEntitlements } from "src/app/subscription/subscriptionUtils";
import "./WelcomeDiscoverMore.scss";

const DISCOVER_MORE_FEATURES = [
  SubscriptionEntitlements.SocialInsights,
  SubscriptionEntitlements.PublicationSentiments,
  SubscriptionEntitlements.Forms,
  SubscriptionEntitlements.CouponsIntegration,
  SubscriptionEntitlements.ClientMode,
  SubscriptionEntitlements.WsXtrmExtension,
  SubscriptionEntitlements.ContactDataVisibility,
  SubscriptionEntitlements.WsMessengerExtension,
  SubscriptionEntitlements.DictionaryManager,
  SubscriptionEntitlements.WhiteLabel,
  SubscriptionEntitlements.APIAccess,
  SubscriptionEntitlements.StorePublishedContentsExtension,
];

function WelcomeDiscoverMore() {
  return (
    <section className="welcome-discover-more">
      <PageHeader
        className="welcome-discover-more__header"
        title={
          <IDHFormattedMessage
            id="ws_discover_more"
            defaultMessage="Discover more"
          />
        }
      />

      <HorizontalScroller disableWheelScroll>
        <div className="welcome-discover-more__container">
          {DISCOVER_MORE_FEATURES.map((feature) => (
            <PlanUpgradeNeededBox
              key={feature}
              feature={feature}
              variant="info"
            />
          ))}
        </div>
      </HorizontalScroller>
    </section>
  );
}

export default WelcomeDiscoverMore;
